Ext.define('SA.VectorMapBusinessesListWindow', {
    alias: 'widget.vector-map-businesses-list-window',
    extend: 'SA.view.AnchoredWindow',

    cls: 'x-selectable sa-vector-map-businesses-list-window',
    floating: true,
    page: 1,

    fields: [
        'legal_name', 'dba1', 'street_address', 'city', 'state_abbrv', 'zip', 'sales_volume',
        'local_employees', 'year_started', 'lob', 'primary_naics', 'primary_sic'
    ],

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-vector-map-businesses-list-header',

            items: [
                {
                    xtype: 'component',
                    itemId: 'top-bar',

                    tpl: [
                        '<div class="sa-vector-map-businesses-list-header-title">Business Points</div>',
                        '<div class="sa-vector-map-businesses-list-header-vicinity-wrap">',
                            '<div class="sa-vector-map-businesses-list-header-vicinity-label">Vicinity:</div>',
                            '<div class="sa-vector-map-businesses-list-header-vicinity-name">',
                                '<tpl if="locationName">{locationName:htmlEncode}<tpl else>-</tpl>',
                            '</div>',
                        '</div>',
                        '<div class="sa-vector-map-businesses-list-header-business-count">{countText}</div>'
                    ]
                }, {
                    xtype: 'close-button'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-vector-map-businesses-list-body',
            itemId: 'body',

            items: [
                {
                    xtype: 'businesses-list-window-list'
                }
            ]
        }, {
            xtype: 'sa-paging-toolbar'
        }
    ],

    initComponent() {
        this.callParent();

        this.form = this.down('form');
        this.body = this.down('#body');
        this.grid = this.down('businesses-list-window-list');
        this.topBar = this.down('#top-bar');
        this.pagingToolbar = this.down('sa-paging-toolbar');

        this.pagingToolbar.on('change:page', this.onChangePage, this);

        this.refreshTopBar();

        this.grid.on('change:selected', this.onChangeSelected, this);

        this.loadBusinesses();
    },

    hideInfo(cb, scope) {
        var form = this.form,
            bodyWidth = this.body.getWidth();

        this.showing = false;

        if (this.currentSlideAnim) {
            this.currentSlideAnim.end();
        }

        this.currentSlideAnim = new Ext.fx.Anim({
            duration: 150,
            target: form,

            to: {
                left: bodyWidth
            },

            listeners: {
                afteranimate: () => {
                    this.currentSlideAnim = null;
                    Ext.callback(cb, scope);
                }
            }
        });
    },

    initEvents() {
        var stop = {fn: Ext.emptyFn, stopPropagation: true};

        this.callParent();

        this.el.on({
            click: stop,
            dblclick: stop,
            mousedown: stop,
            mousewheel: stop,

            keydown: {
                delegate: '.sa-vector-map-businesses-list',

                fn: ev => {
                    var increment = 1,
                        grid = this.grid,
                        selected = grid.getSelected(),
                        page;

                    switch (ev.getKey()) {
                        case ev.PAGE_DOWN:
                            increment *= -1;
                        case ev.PAGE_UP:
                            increment *= 10;
                        case ev.UP:
                            increment *= -1;
                        case ev.DOWN:
                            ev.stopEvent();

                            if (selected) {
                                selected += increment;
                            }
                            else if (Math.abs(increment) === 1) {
                                selected = Math.round(this.page * 10 - 4.5 * (increment + 1));
                            }
                            else {
                                selected = null;
                            }

                            if (selected == null) {
                                page = Math.round(this.page + increment / 10);
                            }
                            else {
                                selected = Ext.Number.constrain(selected, 1, this.businesses.length);

                                grid.setSelected(selected);

                                page = Math.ceil(selected / 10);
                            }

                            this.pagingToolbar.setPage(page);
                        break;
                    }
                }
            }
        });
    },

    async loadBusinesses() {
        var {country} = SA.data.BusinessSearches.get(this.map.getBusinessSearch()),
            locationSeries = ['in', 'locationSeries', ...this.point.properties.locationSeries.split('|')],
            select = this.fields.filter(field => SA.data.BusinessSearches.isFieldAllowed(country, field)),
            businesses = await SA.BusinessesRequests.get({locationSeries, select}, country);

        if (!this.isDestroyed) {
            this.setBusinesses(businesses);
        }
    },

    onChangePage() {
        var oldPage = this.page,
            page = this.pagingToolbar.getPage(),
            grid = this.grid,
            selected;

        if (oldPage !== page) {
            this.page = page;

            this.refreshList();

            selected = grid.getSelected();

            if (selected && Math.ceil(selected / 10) !== page) {
                grid.setSelected(null);
            }
        }
    },

    onChangeSelected() {
        var selected = this.grid.getSelected(),
            form = this.form,
            Businesses = SA.data.BusinessSearches,
            businessSearch = this.map.getBusinessSearch(),
            {country} = Businesses.get(businessSearch),
            salesVolume = Businesses.isFieldAllowed(country, 'sales_volume'),
            localEmployees = Businesses.isFieldAllowed(country, 'local_employees'),
            yearStarted = Businesses.isFieldAllowed(country, 'year_started'),
            isPremium = salesVolume || localEmployees || yearStarted,
            tpl;

        if (selected == null) {
            this.hideInfo(form.hide, form);

            return;
        }

        if (!form) {
            tpl = [
                '<div class="sa-vector-map-businesses-list-info-legal-name">{legal_name}</div>',
                '<div class="sa-vector-map-businesses-list-other-name">{dba1}</div>',
                '<div class="sa-vector-map-businesses-list-info-address">',
                    '<div>{street_address}</div>',
                    '<div>{city}, {state_abbrv}, {zip}</div>',
                '</div>',
                '<div class="sa-vector-map-businesses-list-info-divider"></div>',
                '<div class="sa-vector-map-businesses-list-info-detail-row">',
                    '<div class="sa-vector-map-businesses-list-info-detail-label">Line of Business:</div>',
                    '<div class="sa-vector-map-businesses-list-info-detail-lob">{lob}</div>',
                '</div>',
                '<div class="sa-vector-map-businesses-list-info-detail-row">',
                    '<div class="sa-vector-map-businesses-list-info-detail-label">SIC:</div>',
                    '<div class="sa-vector-map-businesses-list-info-detail-value">{primary_sic}</div>',
                    '<div class="sa-vector-map-businesses-list-info-detail-code-desc">{[SA.data.SicCodes.getDescription(values.primary_sic)]}</div>',
                '</div>',
                '<div class="sa-vector-map-businesses-list-info-detail-row">',
                    '<div class="sa-vector-map-businesses-list-info-detail-label">NAICS:</div>',
                    '<div class="sa-vector-map-businesses-list-info-detail-value">{primary_naics}</div>',
                    '<div class="sa-vector-map-businesses-list-info-detail-code-desc">{[SA.data.NaicsCodes.getDescription(values.primary_naics)]}</div>',
                '</div>'
            ];

            if (isPremium) {
                if (salesVolume) {
                    tpl.push(
                        '<div class="sa-vector-map-businesses-list-info-detail-row">',
                            '<div class="sa-vector-map-businesses-list-info-detail-label">Sales Volume:</div>',
                            '<div class="sa-vector-map-businesses-list-info-detail-value">${sales_volume:number("0,000")}</div>',
                        '</div>'
                    );
                }

                if (localEmployees) {
                    tpl.push(
                        '<div class="sa-vector-map-businesses-list-info-detail-row">',
                            '<div class="sa-vector-map-businesses-list-info-detail-label">Local Employees:</div>',
                            '<div class="sa-vector-map-businesses-list-info-detail-value">{local_employees:number("0,000")}</div>',
                        '</div>'
                    );
                }

                if (yearStarted) {
                    tpl.push(
                        '<div class="sa-vector-map-businesses-list-info-detail-row">',
                            '<div class="sa-vector-map-businesses-list-info-detail-label">Year Started:</div>',
                            '<div class="sa-vector-map-businesses-list-info-detail-value">{year_started}</div>',
                        '</div>'
                    );
                }
            }

            this.form = this.body.add({
                xtype: 'simple-container',
                cls: 'sa-vector-map-businesses-list-info',
                hidden: true,

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-vector-map-businesses-list-info-collapse',
                        html: '<svg class="sa-vector-map-businesses-list-info-collapse-arrow"><use href="#sa-icon-arrow-left"></use></svg>Back to list',
                        overCls: 'sa-vector-map-businesses-list-info-collapse-over',

                        listeners: {
                            el: {
                                click: () => {
                                    this.grid.setSelected(null);
                                }
                            }
                        }
                    }, {
                        xtype: 'component',
                        itemId: 'listInfoContent',
                        tpl
                    }
                ]
            });
        }

        this.showInfo();
    },

    refreshList() {
        var list = this.grid,
            page = this.page,
            businesses = this.businesses,
            start = (page - 1) * 10;

        if (!businesses) {
            return;
        }

        list.update({
            numberWidth: start > 989 ? 40 : start > 89 ? 34 : 28,

            rows: businesses.slice(start, start + 10).map((business, index) => {
                return {
                    name: business.legal_name,
                    number: start + 1 + index
                };
            })
        });
    },

    refreshTopBar() {
        var {count} = this.point.properties,
            countText;

        if (count === 1) {
            countText = '1 business';
        }
        else if (count < 10000) {
            countText = count + ' businesses';
        }
        else {
            countText = '10000+ businesses';
        }

        this.topBar.update({countText, locationName: this.vicinity?.properties.name});
    },

    setBusinesses(businesses) {
        var grid = this.grid;

        this.businesses = businesses.sort((a, b) => {
            var aName = a.legal_name,
                bName = b.legal_name;

            return aName === bName ? 0 : aName < bName ? -1 : 1;
        });

        this.pagingToolbar.setPageCount(Math.ceil(businesses.length / 10));

        this.refreshList();

        setTimeout(() => {
            if (!grid.getSelected()) {
                grid.setSelected(1);
            }
        }, 800);
    },

    showInfo(cb, scope) {
        var form = this.form,
            record = this.businesses[this.grid.getSelected() - 1],
            bodyWidth = this.body.getWidth(),
            numberColumnWidth = this.grid.getNumberColumnWidth();

        form.width = bodyWidth - numberColumnWidth;
        form.down('#listInfoContent').update(record);

        if (this.showing) {
            return;
        }

        this.showing = true;

        if (this.currentSlideAnim) {
            this.currentSlideAnim.end();
        }

        form.setLocalX(bodyWidth);

        form.show();

        this.currentSlideAnim = new Ext.fx.Anim({
            duration: 150,
            target: form,

            from: {
                left: bodyWidth
            },

            to: {
                left: numberColumnWidth
            },

            listeners: {
                afteranimate: () => {
                    this.currentSlideAnim = null;
                    Ext.callback(cb, scope);
                }
            }
        });
    }
});